export const SuccessIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12ZM11.3152 17.136L17.7248 9.12326C18.0005 8.7786 17.9446 8.27569 17.6 7.99997C17.2553 7.72427 16.7525 7.78011 16.4767 8.12469L11.0848 14.8624L7.52643 11.8975C7.18708 11.6148 6.68278 11.6607 6.4 12C6.11723 12.3393 6.16306 12.8436 6.50238 13.1264L11.3152 17.1376V17.136Z"
                fill="#5FB257"
            />
        </svg>
    );
};
